import { render, staticRenderFns } from "./MailLog.vue?vue&type=template&id=3affa2d9&"
import script from "./MailLog.vue?vue&type=script&lang=js&"
export * from "./MailLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports